package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.components.widgets.FilterCheckGroup
import io.horion.cv.models.ExperienceLevel
import io.horion.cv.models.JobType
import io.horion.cv.styles.FormlocalisationStyle
import io.horion.cv.uiState.JobUiState
import io.horion.cv.utils.Colors
import io.horion.cv.utils.label
import io.horion.cv.viewModel.JobViewModel
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Input


@Composable
fun FilterContent(
    state: JobUiState,
    viewModel: JobViewModel,
    breakpoint: Breakpoint
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 15.px)
    ) {
        SpanText(
            "Filtres",
            modifier = Modifier
                .fontSize(28.px)
                .fontWeight(FontWeight.Bold)
                .margin(bottom = 10.px)
        )

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Colors.LightGray)
                .margin(topBottom = 15.px)
        )

        LocalisationForm(
            label = "Localisation",
            placeholder = "Douala",
            value = state.searchQuery,
            onValueChange = { viewModel.updateSearchQuery(it) }
        )

        FilterCheckGroup(
            title = "Type de contrat",
            items = JobType.entries,
            checkedItems = listOfNotNull(state.filterType),
            onCheckedChange = { item, isChecked ->
                viewModel.filterByType(if (isChecked) item else null)
            },
            label = { it.label() },
            breakpoint = breakpoint
        )

        FilterCheckGroup(
            title = "Expérience",
            items = ExperienceLevel.values().toList(),
            checkedItems = listOfNotNull(state.filterExperienceLevel),
            onCheckedChange = { item, isChecked ->
                viewModel.filterByExperience(if (isChecked) item else null)
            },
            label = { it.label() },
            breakpoint = breakpoint
        )

        FilterCheckGroup(
            title = "Mode de travail",
            items = listOf(true),
            checkedItems = if (state.filterRemoteOnly) listOf(true) else emptyList(),
            onCheckedChange = { _, isChecked ->
                viewModel.filterRemoteOnly(isChecked)
            },
            label = { "Télétravail uniquement" },
            breakpoint = breakpoint
        )
    }
}
// Composant pour le drawer de filtre (glisse depuis la gauche, sous le header)
@Composable
fun FilterDrawer(
    isVisible: Boolean,
    onDismiss: () -> Unit,
    state: JobUiState,
    viewModel: JobViewModel,
    breakpoint: Breakpoint,
    isDark: Boolean
) {
    var isAnimating by remember { mutableStateOf(false) }

    LaunchedEffect(isVisible) {
        isAnimating = true
        if (isVisible) {
            delay(10)
            isAnimating = false
        } else {
            delay(300)
            isAnimating = false
        }
    }

    // Hauteur du header selon le breakpoint (cf Navigationbar)
    val headerHeight = if (breakpoint <= Breakpoint.SM) 158.px else 168.px

    if (isVisible || isAnimating) {
        // Overlay : commence SOUS le header, ne le recouvre jamais
        Box(
            modifier = Modifier
                .position(Position.Fixed)
                .top(headerHeight)
                .left(0.px)
                .right(0.px)
                .bottom(0.px)
                .backgroundColor(rgba(0, 0, 0, 0.35))
                .onClick { onDismiss() }
        ) {

            // Drawer : à GAUCHE, sous le header, scroll indépendant de la liste des jobs
            Box(
                modifier = Modifier
                    .width(85.percent)
                    .backgroundColor(if (isDark) Colors.Primary else Colors.White)
                    .position(Position.Fixed)
                    .top(headerHeight)
                    .left(0.px)
                    .bottom(0.px)
                    .styleModifier {
                        property("overflow-y", "auto")
                        property("-webkit-overflow-scrolling", "touch")
                    }
                    .onClick { it.stopPropagation() }
            ) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(20.px)
                ) {
                    // bouton x pour fermer
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End
                    ) {
                        Button(
                            onClick = { onDismiss() },
                            modifier = Modifier
                                .size(40.px)
                                .backgroundColor(if (isDark) Colors.Black else Colors.LightGray)
                                .borderRadius(20.px)
                        ) {
                            SpanText("✕", modifier = Modifier.fontSize(16.px))
                        }
                    }

                    // Contenu des filtres
                    FilterContent(
                        state = state,
                        viewModel = viewModel,
                        breakpoint = breakpoint
                    )

                    // Bouton appliquer en bas
                    Button(
                        onClick = { onDismiss() },
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 16.px)
                            .borderRadius(8.px)
                            .padding(topBottom = 12.px)
                    ) {
                        SpanText(
                            "Appliquer les filtres",
                            modifier = Modifier.fontSize(16.px)
                                .fontWeight(FontWeight.Medium),
                        )
                    }
                }
            }
        }
    }
}